module.exports = __webpack_public_path__ + "img/user-graduate.c4594b31.svg";